import React from 'react';

import RichText from 'components/RichText/RichText';
import { TextBlockSection as TextBlockSectionTypes } from 'containers/PrivacyPage/PrivacyPage.types';

import * as S from './TextBlockSection.styles';

export interface TextBlockSectionProps {
  data: TextBlockSectionTypes;
}

const defaultProps: Partial<TextBlockSectionProps> = {};

const TextBlockSection: React.FunctionComponent<TextBlockSectionProps> = ({
  data,
}) => {
  return (
    <S.TextBlockSectionWrapper>
      {data.privacyTextBlock.map(block => (
        <S.Block key={block.title}>
          <S.Title>{block.title}</S.Title>
          <S.Content>
            <RichText richText={block.richText} />
          </S.Content>
        </S.Block>
      ))}
    </S.TextBlockSectionWrapper>
  );
};

TextBlockSection.defaultProps = defaultProps;

export default TextBlockSection;
